import { render, staticRenderFns } from "./AssetHero.vue?vue&type=template&id=245a470d&scoped=true&"
import script from "./AssetHero.vue?vue&type=script&lang=js&"
export * from "./AssetHero.vue?vue&type=script&lang=js&"
import style0 from "./AssetHero.vue?vue&type=style&index=0&id=245a470d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a470d",
  null
  
)

export default component.exports